import { useEffect, useRef, useState } from "react";
import "./GlueFinal.css";

const segments = [
  { key: "domain", text: "US-DE" },
  { key: "n", text: ".N" },
  { key: "doc", text: "-DOC" },
  { key: "date", text: "-20251208" }, // ✅ updated
  { key: "id", text: ":10429045" },   // ✅ updated
];

const labels = {
  domain: ["Registration Authority", "Country & Subdivision", "ISO 3166", "Delaware, USA"],
  n: ["GLUE ID Type", ""],
  doc: ["Registrar", "Division of", "Corporations"],
  date: ["Registration Date", "ISO 8601 format"],
  id: ["Registrar ID", "Delaware, USA"],
};

export default function GlueFinal() {
  const textRef = useRef(null);
  const [positions, setPositions] = useState([]);
  const [active, setActive] = useState(0);

  useEffect(() => {
    const i = setInterval(() => {
      setActive((prev) => (prev + 1) % segments.length);
    }, 1400);
    return () => clearInterval(i);
  }, []);

  useEffect(() => {
    if (!textRef.current) return;
    const spans = textRef.current.querySelectorAll("tspan");
    const pos = [];

    spans.forEach((s) => {
      const b = s.getBBox();
      pos.push({
        x: b.x + b.width / 2,
        left: b.x,
        right: b.x + b.width,
      });
    });

    setPositions(pos);
  }, []);

  return (
    <div className="glue-landing-animation-container">
      <svg viewBox="0 -30 800 460" className="glue-landing-animation-svg">

        {/* TEXT */}
        <text x="50" y="130" className="glue-landing-animation-main-text" ref={textRef}>
          {segments.map((seg, i) => (
            <tspan
              key={i}
              className={active === i ? "glue-landing-animation-active-text" : ""}
            >
              {seg.text}
            </tspan>
          ))}
        </text>

        {positions.length === segments.length && (
          <>
            {/* ===== NEW TOP SUPER LABEL ===== */}
            <text
              x={(positions[0].left + positions[4].right) / 2}
              y="-10"
              className="glue-landing-animation-top-label"
            >
              ISO 8000 115/116 Quality Identifier
            </text>

            {/* ===== NEW TOP SUPER BRACKET ===== */}
            <path
              d={`M${positions[0].left} 25 
                  Q${positions[0].left} 10 ${positions[0].left + 20} 10 
                  L${positions[4].right - 20} 10 
                  Q${positions[4].right} 10 ${positions[4].right} 25`}
              className="glue-landing-animation-bracket"
            />

            {/* ===== EXISTING LABELS ===== */}
            <text
              x={(positions[0].left + positions[0].right) / 2}
              y="40"
              className="glue-landing-animation-top-label"
            >
              Domain
            </text>

            <text
              x={(positions[1].left + positions[3].right) / 2}
              y="40"
              className="glue-landing-animation-top-label"
            >
              Subdomain
            </text>

            <text
              x={(positions[4].left + positions[4].right) / 2}
              y="40"
              className="glue-landing-animation-top-label"
            >
              Identifier
            </text>

            {/* ===== EXISTING BRACKETS ===== */}
            <path
              d={`M${positions[0].left} 75 Q${positions[0].left} 60 ${positions[0].left + 20} 60 
                  L${positions[0].right - 20} 60 
                  Q${positions[0].right} 60 ${positions[0].right} 75`}
              className="glue-landing-animation-bracket"
            />

            <path
              d={`M${positions[1].left} 75 Q${positions[1].left} 60 ${positions[1].left + 20} 60 
                  L${positions[3].right - 20} 60 
                  Q${positions[3].right} 60 ${positions[3].right} 75`}
              className="glue-landing-animation-bracket"
            />

            <path
              d={`M${positions[4].left} 75 Q${positions[4].left} 60 ${positions[4].left + 20} 60 
                  L${positions[4].right - 20} 60 
                  Q${positions[4].right} 60 ${positions[4].right} 75`}
              className="glue-landing-animation-bracket"
            />

            {/* ===== LINES ===== */}
            {positions.map((p, i) => {
              const isN = i === 1;
              return (
                <line
                  key={i}
                  x1={p.x}
                  y1={130}
                  x2={p.x}
                  y2={isN ? 240 : 260}
                  className={`glue-landing-animation-line ${active === i ? "glue-landing-animation-active-line" : ""
                    }`}
                />
              );
            })}

            {/* ===== BOXES ===== */}
            {positions.map((p, i) => {
              const isN = i === 1;
              const seg = segments[i];
              const lines = labels[seg.key];

              // Better dynamic sizing
              const width = Math.max(
                isN ? 90 : 130,
                Math.max(...lines.map((l) => l.length)) * 8
              );

              // Manual whitespace adjustments to avoid overlap
              let adjustedX = p.x;

              if (i === 0) adjustedX -= 28; // move Registration Authority box left
              if (i === 2) adjustedX += 32; // move Registrar box right
              if (i === 3) adjustedX += 32; // slight spacing for date box

              return (
                <g key={i}>
                  <rect
                    x={adjustedX - width / 2}
                    y={isN ? 190 : 260}
                    width={width}
                    height={lines.length * 20 + 20}
                    rx="6"
                    className={`glue-landing-animation-box ${active === i ? "glue-landing-animation-active-box" : ""
                      }`}
                  />
                  {lines.map((t, idx) => (
                    <text
                      key={idx}
                      x={adjustedX}
                      y={isN ? 220 : 280 + idx * 18}
                      textAnchor="middle"
                      className="glue-landing-animation-box-text"
                    >
                      {t}
                    </text>
                  ))}
                </g>
              );
            })}
          </>
        )}
      </svg>
    </div>
  );
}